import React from "react";
import SEO from "../components/SEO";
import styled from "styled-components";
import { Link } from "react-router-dom";

// Même mise en page que la politique de confidentialité
const MentionsContainer = styled.div`
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
  color: #b0b0b0;

  h1 {
    color: #13519a;
    margin-bottom: 1.5rem;
    text-align: center;
  }

  h2 {
    color: #13519a;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 1rem;
  }

  a {
    color: #ef6500;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

// Informations légales (source : attestation RNE / INPI du 26/09/2026)
// Présidente : la société NAVYMAB (SASU). Le directeur de la publication est
// obligatoirement la personne physique qui la représente (loi du 29/07/1982, art. 93-2).
const CAPITAL = "10 000 €";
const REPRESENTANT_PRESIDENTE = "M. Laurent CORBEL";

const MentionsLegales = () => {
  return (
    <MentionsContainer>
      <SEO
        title="Mentions légales | ImpactIsol"
        description="Mentions légales du site impactisol.com : éditeur, hébergeur, propriété intellectuelle."
      />
      <h1>Mentions légales</h1>

      <h2>Éditeur du site</h2>
      <p>
        <strong>IMPACTISOL</strong>, SAS (société par actions simplifiée) au
        capital de {CAPITAL}
        <br />
        Siège social : 500 Route du Ruisset, 38360 Noyarey, France
        <br />
        RCS Grenoble — SIREN 953 329 364 — SIRET 953 329 364 00020
        <br />
        N° TVA intracommunautaire : FR43 953 329 364
        <br />
        Téléphone : <a href="tel:+33625837471">+33 6 25 83 74 71</a>
        <br />
        E-mail : <a href="mailto:contact@impactisol.fr">contact@impactisol.fr</a>
      </p>
      <p>Directeur de la publication : {REPRESENTANT_PRESIDENTE}</p>

      <h2>Conception et réalisation</h2>
      <p>Site conçu, réalisé et maintenu par XCTech.</p>

      <h2>Hébergement</h2>
      <p>
        Amazon Web Services EMEA SARL
        <br />
        38 avenue John F. Kennedy, L-1855 Luxembourg
        <br />
        <a href="https://aws.amazon.com/fr/" target="_blank" rel="noopener noreferrer">
          aws.amazon.com
        </a>
      </p>

      <h2>Propriété intellectuelle</h2>
      <p>
        L’ensemble des contenus de ce site (textes, photographies de chantiers,
        logo) est la propriété d’IMPACTISOL, sauf mention contraire. Toute
        reproduction, même partielle, est interdite sans autorisation écrite
        préalable.
      </p>

      <h2>Données personnelles et cookies</h2>
      <p>
        Le traitement de vos données personnelles et l’utilisation des cookies
        sont détaillés dans notre{" "}
        <Link to="/politique-confidentialite">politique de confidentialité</Link>.
      </p>
    </MentionsContainer>
  );
};

export default MentionsLegales;
